import { Event } from '../domain/Event'

export const eventList: Event[] = [
]
